import { messageTypes } from '../messages/messages.types'
import { widgetTypes } from './widget.types'
import { LAUNCHER_CONTENT_STATE, MESSENGER_TAB_STATE, HELP_TAB_STATE } from 'app/constants/launcherContentStates'

export const INITIAL_STATE = {
  widgetInfo: {
    languageInfo: {},
    loading: false,
    data: null,
    showWidget: false,
    showLauncher: false,
    showTrigger: false,
    headerExpand: true,
    headerExpandHeight: 80,
    animateWidget: {
      status: false,
      animationType: 'flip',
    },
    isOfficeHour: false,
    disableTrigger: false,
    widgetSleepMode: false,
    department: {
      loading: false,
      data: null,
    },
    launcherInfo: {
      newMessagesCount: 0,
      content: LAUNCHER_CONTENT_STATE.MAIN_COVER, // firstChat | conversationsList | mainCover
    },
    isWidgetReady: false,
    faq: null,
    isWidgetWideOpen: false,
    currentTab: 0,
    prevTab: null,
    helpTabState: HELP_TAB_STATE.FAQ_LIST, // FAQ_LIST | FAQ_DETAIL
    helpTabCurrentFaq: null,
    helpTabInputFocus: false,
    messengerTabState: MESSENGER_TAB_STATE.DEPARTMENTS, // DEPARTMENTS | CHAT
    autoMessageContentSize: 0,
  },
  injectedStyles: null,
  injectedPosition: null,
  activeTriggerMsg: null,
}

const widgetReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case widgetTypes.FETCH_WIDGET_INFO_START:
      return {
        ...state,
        widgetInfo: {
          ...state.widgetInfo,
          loading: true,
        },
      }

    case widgetTypes.SET_WIDGET_INFO:
      return {
        ...state,
        widgetInfo: {
          ...state.widgetInfo,
          loading: false,
          data: action.payload.data,
          languageInfo: action.payload.languageInfo,
          faq: action.payload.faq,
        },
      }

    case widgetTypes.SET_ACTIVE_TRIGGER_MESSAGE:
      return {
        ...state,
        activeTriggerMsg: action.payload,
      }

    case widgetTypes.SET_SHOW_WIDGET:
      return {
        ...state,
        widgetInfo: {
          ...state.widgetInfo,
          showWidget: action.payload,
        },
      }

    case widgetTypes.SET_SHOW_LAUNCHER:
      return {
        ...state,
        widgetInfo: {
          ...state.widgetInfo,
          showLauncher: action.payload,
          showTrigger: action.payload ? false : state.widgetInfo.showTrigger,
        },
      }
    case widgetTypes.SET_SHOW_TRIGGER:
      return {
        ...state,
        widgetInfo: {
          ...state.widgetInfo,
          showTrigger: action.payload && !state.widgetInfo.showLauncher ? true : false,
        },
      }

    case widgetTypes.SET_LAUNCHER_CONTENT:
      return {
        ...state,
        widgetInfo: {
          ...state.widgetInfo,
          launcherInfo: {
            ...state.widgetInfo.launcherInfo,
            content: action.payload,
          },
        },
      }

    case widgetTypes.SET_HEADER_EXPAND:
      return {
        ...state,
        widgetInfo: {
          ...state.widgetInfo,
          headerExpand: action.payload,
        },
      }

    case widgetTypes.SET_ANIMATE_WIDGET:
      return {
        ...state,
        widgetInfo: {
          ...state.widgetInfo,
          animateWidget: {
            status: action.payload.status,
            animationType: action.payload.animationType,
          },
        },
      }
    case widgetTypes.SET_OFFICE_HOURE:
      return {
        ...state,
        widgetInfo: {
          ...state.widgetInfo,
          isOfficeHour: action.payload,
        },
      }

    case widgetTypes.SET_DISABLE_TRIGGER:
      return {
        ...state,
        widgetInfo: {
          ...state.widgetInfo,
          disableTrigger: action.payload,
        },
      }

    case widgetTypes.SET_DISABLE_TRIGGER_MESSAGES:
      return {
        ...state,
        widgetInfo: {
          ...state.widgetInfo,
          data: {
            ...state.widgetInfo.data,
            trigger: {
              ...state.widgetInfo.data.trigger,
              messages: [],
            },
          },
        },
      }

    case widgetTypes.SET_DEPARTMENT:
      return {
        ...state,
        widgetInfo: {
          ...state.widgetInfo,
          department: {
            loading: false,
            data: action.payload,
          },
        },
      }

    case widgetTypes.TOGGLE_LAUNCHER:
      return {
        ...state,
        widgetInfo: {
          ...state.widgetInfo,
          showLauncher: !state.widgetInfo.showLauncher,
          showTrigger: false,
        },
      }
    case widgetTypes.SET_WIDGET_READY:
      return {
        ...state,
        widgetInfo: {
          ...state.widgetInfo,
          isWidgetReady: true,
        },
      }

    case widgetTypes.SET_WIDGET_SIZE_WIDE_OPEN:
      return {
        ...state,
        widgetInfo: {
          ...state.widgetInfo,
          isWidgetWideOpen: action.payload,
        },
      }

    case widgetTypes.SET_WIDGET_TAB:
      return {
        ...state,
        widgetInfo: {
          ...state.widgetInfo,
          prevTab: state.widgetInfo.currentTab,
          currentTab: action.payload,
        },
      }

    case widgetTypes.SET_HELP_TAB_STATE:
      return {
        ...state,
        widgetInfo: {
          ...state.widgetInfo,
          helpTabState: action.payload,
        },
      }

    case widgetTypes.SET_HELP_TAB_FAQ:
      return {
        ...state,
        widgetInfo: {
          ...state.widgetInfo,
          helpTabCurrentFaq: action.payload,
        },
      }
    case widgetTypes.SET_HELP_TAB_INPUT_FOCUS:
      return {
        ...state,
        widgetInfo: {
          ...state.widgetInfo,
          helpTabInputFocus: action.payload,
        },
      }

    case widgetTypes.SET_MESSENGER_TAB_STATE:
      return {
        ...state,
        widgetInfo: {
          ...state.widgetInfo,
          messengerTabState: action.payload,
        },
      }

    case widgetTypes.SET_INJECTED_STYLES:
      return {
        ...state,
        injectedStyles: action.payload,
      }

    case widgetTypes.SET_INJECTED_POSITION:
      return {
        ...state,
        widgetInfo: {
          ...state.widgetInfo,
          injectedPosition: action.payload,
        },
      }

    case widgetTypes.SET_AUTO_MESSAGE_SIZE:
      return {
        ...state,
        widgetInfo: {
          ...state.widgetInfo,
          autoMessageContentSize: action.payload,
        },
      }

    case widgetTypes.SET_FORMS: {
      return {
        ...state,
        widgetInfo: {
          ...state.widgetInfo,
          data: {
            ...state.widgetInfo.data,
            forms: {
              ...state.widgetInfo.data.forms,
              ...action.payload,
            },
          },
        },
      }
    }

    case widgetTypes.SET_HEADER_EXPANDED_HEIGHT: {
      return {
        ...state,
        widgetInfo: {
          ...state.widgetInfo,
          headerExpandHeight: action.payload,
        },
      }
    }

    case messageTypes.OPEN_WIDGET_AUTO_MSG_ACTION: {
      // there is an state where user has already opened widget. In this occasion in order to have a good UX content of the page won't change and previous launcher content will remain
      const newLauncherContent = state.widgetInfo.showLauncher
        ? state.widgetInfo.launcherInfo.content
        : action.payload.launcherContentState

      return {
        ...state,
        widgetInfo: {
          ...state.widgetInfo,
          showLauncher: true,
          showTrigger: false,
          launcherInfo: {
            ...state.widgetInfo.launcherInfo,
            content: newLauncherContent,
          },
        },
      }
    }

    default:
      return state
  }
}

export default widgetReducer
// widgetInfo.data.personalize.position
